export const APP_TIMEOUTS = {
	IDLE: 14400000
};

